import type { ReactNode } from "react";

export function MessageHoverMetadata({
  side,
  pinned = false,
  timestamp,
  children,
}: {
  side: "start" | "end";
  pinned?: boolean;
  timestamp?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div data-testid="message-action-footer" className="message-action-footer">
      <div
        data-testid="message-hover-rail"
        data-side={side}
        data-pinned={pinned || undefined}
        className="message-action-rail"
      >
        {children}
      </div>
      {timestamp}
    </div>
  );
}
